<template>
  <div class="hub-activity-rows">
    <button v-for="item in entries" :key="item.id" type="button" class="hub-activity-row" @click="$emit('select', item)">
      <span class="hub-activity-symbol"><v-icon color="#a3c6c4" size="24">{{ item.icon }}</v-icon></span>
      <span class="hub-activity-copy"><strong>{{ item.title }}</strong><span>{{ dateLabel(item) }} · {{ item.sourceNames.join(' + ') }}</span>
        <small v-if="item.pendingOverlap" class="hub-overlap-note">Mögliche Doppelung · noch nicht mitgezählt</small>
        <small v-else>{{ statusLabel(item.status) }}<template v-if="item.durationSource === 'course_schedule'"> · Kursplandauer</template><template v-if="item.sources.length > 1 && item.status === 'completed'"> · einmal gezählt</template></small>
      </span>
      <span class="hub-activity-duration">{{ duration(item.durationSeconds) }}<v-icon small color="#aaa">mdi-chevron-right</v-icon></span>
    </button>
  </div>
</template>
<script>
import { hubDuration, hubStatusLabel } from "@/services/customerHubActivityData"
export default {
  props: { entries: { type: Array, default: () => [] }, showDate: { type: Boolean, default: false } },
  methods: {
    duration: hubDuration,
    statusLabel: hubStatusLabel,
    dateLabel(item) {
      const day = this.showDate ? this.$moment(item.date).format("DD.MM.YYYY") : ""
      const time = (item.timeIsExact || item.scheduledTimeIsExact) && item.startedAt
        ? this.$moment(item.startedAt).format("HH:mm") + (!item.timeIsExact ? " laut Kursplan" : "") : "Zeit nicht erfasst"
      return [day, time].filter(Boolean).join(" · ")
    },
  },
}
</script>
<style scoped>
.hub-activity-row { width: 100%; display: flex; align-items: center; gap: 12px; padding: 16px 0; color: #fff; text-align: left; border-bottom: 1px solid #ffffff12; }
.hub-activity-symbol { display: flex; align-items: center; justify-content: center; background: #a3c6c414; border-radius: 14px; min-width: 44px; height: 44px; }
.hub-activity-copy { flex: 1; min-width: 0; }
.hub-activity-copy strong, .hub-activity-copy span, .hub-activity-copy small { display: block; line-height: 1.5; }
.hub-activity-copy strong { font-size: 15px; overflow-wrap: anywhere; }
.hub-activity-copy span, .hub-activity-copy small { font-size: 11px; color: #aaa; }
.hub-activity-copy .hub-overlap-note { color: #f4c87e; }
.hub-activity-duration { display: flex; align-items: center; gap: 6px; max-width: 100px; font-size: 12px; color: #ccc; text-align: right; }
button:focus-visible { outline: 2px solid #a3c6c4; outline-offset: 3px; }
@media(max-width: 380px) { .hub-activity-duration { max-width: 68px; font-size: 11px; } .hub-activity-row { gap: 8px; } }
</style>
